const firebaseConfig = {
    apiKey: "AIzaSyD_qaay6KKjancFGlAm74PXKISxYrMcUt4",
    authDomain: "molecular-dagnosis.firebaseapp.com",
    projectId: "molecular-dagnosis",
    storageBucket: "molecular-dagnosis.appspot.com",
    messagingSenderId: "192460309186",
    appId: "1:192460309186:web:2861a7521e77b777abf15b"
  };
  export default firebaseConfig;